/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateBerthRequest } from '../model'
// @ts-ignore
import type { CreateBerthResponse } from '../model'
// @ts-ignore
import type { DeleteBerthRequest } from '../model'
// @ts-ignore
import type { GetBerthsResponse } from '../model'
// @ts-ignore
import type { UpdateBerthRequest } from '../model'
/**
 * BerthsApi - axios parameter creator
 */
export const BerthsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateBerthRequest} [createBerthRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBerth: async (
      createBerthRequest?: CreateBerthRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Berths`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBerthRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeleteBerthRequest} [deleteBerthRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBerth: async (
      deleteBerthRequest?: DeleteBerthRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Berths`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteBerthRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBerths: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Berths`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateBerthRequest} [updateBerthRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBerth: async (
      updateBerthRequest?: UpdateBerthRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Berths`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBerthRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * BerthsApi - functional programming interface
 */
export const BerthsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BerthsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CreateBerthRequest} [createBerthRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createBerth(
      createBerthRequest?: CreateBerthRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBerthResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createBerth(
        createBerthRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['BerthsApi.createBerth']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeleteBerthRequest} [deleteBerthRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteBerth(
      deleteBerthRequest?: DeleteBerthRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBerth(
        deleteBerthRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['BerthsApi.deleteBerth']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBerths(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBerthsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBerths(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['BerthsApi.getBerths']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateBerthRequest} [updateBerthRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBerth(
      updateBerthRequest?: UpdateBerthRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateBerth(
        updateBerthRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['BerthsApi.updateBerth']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * BerthsApi - factory interface
 */
export const BerthsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BerthsApiFp(configuration)
  return {
    /**
     *
     * @param {CreateBerthRequest} [createBerthRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBerth(
      createBerthRequest?: CreateBerthRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateBerthResponse> {
      return localVarFp
        .createBerth(createBerthRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeleteBerthRequest} [deleteBerthRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBerth(
      deleteBerthRequest?: DeleteBerthRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteBerth(deleteBerthRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBerths(options?: RawAxiosRequestConfig): AxiosPromise<GetBerthsResponse> {
      return localVarFp.getBerths(options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateBerthRequest} [updateBerthRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBerth(
      updateBerthRequest?: UpdateBerthRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updateBerth(updateBerthRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * BerthsApi - object-oriented interface
 */
export class BerthsApi extends BaseAPI {
  /**
   *
   * @param {CreateBerthRequest} [createBerthRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createBerth(createBerthRequest?: CreateBerthRequest, options?: RawAxiosRequestConfig) {
    return BerthsApiFp(this.configuration)
      .createBerth(createBerthRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeleteBerthRequest} [deleteBerthRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteBerth(deleteBerthRequest?: DeleteBerthRequest, options?: RawAxiosRequestConfig) {
    return BerthsApiFp(this.configuration)
      .deleteBerth(deleteBerthRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getBerths(options?: RawAxiosRequestConfig) {
    return BerthsApiFp(this.configuration)
      .getBerths(options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateBerthRequest} [updateBerthRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateBerth(updateBerthRequest?: UpdateBerthRequest, options?: RawAxiosRequestConfig) {
    return BerthsApiFp(this.configuration)
      .updateBerth(updateBerthRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
